import React from 'react'
import clsx from 'clsx'
import { EquipeScore, deduceWinner } from '../../competitions/types'
import styles from './styles.module.scss'
import { MonClubLink } from '../../components/MonClubLink'
import { StructureLogoOrGeneric } from '../../components/StructureLogoOrGeneric'

type TeamScoreProps = {
    homeScore: number | EquipeScore
    awayScore: number | EquipeScore
    homeLogoUrl?: string | null
    awayLogoUrl?: string | null
    homeName: string
    awayName: string
    homeExtStructureId?: number
    awayExtStructureId?: number
    size?: 'medium' | 'large'
    template?: 'home' | 'event'
    updating?: boolean
}

export const TeamScore = ({
    homeScore,
    awayScore,
    homeLogoUrl,
    awayLogoUrl,
    homeName,
    awayName,
    homeExtStructureId,
    awayExtStructureId,
    size = 'medium',
    template = 'event',
    updating,
}: TeamScoreProps) => {
    const winner = deduceWinner({ home: homeScore, away: awayScore })

    return (
        <div
            className={clsx(
                styles.component,
                styles[size],
                styles[template],
                updating && styles.updating,
            )}
        >
            <div className={clsx(styles.halfBlock, styles.left)}>
                <div className={clsx(styles.team, styles.left, styles[size])}>
                    <div className={clsx(styles.teamName, styles.left, styles[size])}>
                        {homeExtStructureId ? (
                            <MonClubLink
                                extStructureId={homeExtStructureId}
                                disableLink={homeLogoUrl === null}
                            >
                                {homeName}
                            </MonClubLink>
                        ) : (
                            homeName
                        )}
                    </div>

                    <div className={clsx(styles.logoWrapper, styles[size])}>
                        <StructureLogoOrGeneric imageUrl={homeLogoUrl ?? ''} title={homeName} />
                    </div>
                </div>

                <div
                    className={clsx(styles.score, styles[size], winner === 'home' && styles.winner)}
                >
                    {homeScore ?? '-'}
                </div>
            </div>

            <div className={clsx(styles.halfBlock, styles.right)}>
                <div
                    className={clsx(styles.score, styles[size], winner === 'away' && styles.winner)}
                >
                    {awayScore ?? '-'}
                </div>

                <div className={clsx(styles.team, styles.right, styles[size])}>
                    <div className={clsx(styles.logoWrapper, styles[size])}>
                        <StructureLogoOrGeneric imageUrl={awayLogoUrl ?? ''} title={awayName} />
                    </div>

                    <div className={clsx(styles.teamName, styles.right, styles[size])}>
                        {awayExtStructureId ? (
                            <MonClubLink
                                extStructureId={awayExtStructureId}
                                disableLink={awayLogoUrl === null}
                            >
                                {awayName}
                            </MonClubLink>
                        ) : (
                            awayName
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
